import { _ as r } from "../internals/export.js";
import { g as t } from "../internals/global.js";
import { g as o } from "../internals/get-built-in.js";
import { c as s } from "../internals/create-property-descriptor.js";
import "../internals/object-define-property.js";
import { h as e } from "../internals/has-own-property.js";
import { a as i } from "../internals/an-instance.js";
import { i as n } from "../internals/inherit-if-required.js";
import { n as a } from "../internals/normalize-string-argument.js";
import { d as p } from "../internals/dom-exception-constants.js";
import { e as c } from "../internals/error-stack-clear.js";
import { d as m } from "../internals/descriptors.js";
import { __exports as l } from "../../../_virtual/object-define-property.js";
var f = l.f,
  j = "DOMException",
  d = o("Error"),
  g = o(j),
  u = function u() {
    i(this, b);
    var r = arguments.length,
      t = a(r < 1 ? void 0 : arguments[0]),
      o = a(r < 2 ? void 0 : arguments[1], "Error"),
      e = new g(t, o),
      p = d(t);
    return p.name = j, f(e, "stack", s(1, c(p.stack, 1))), n(e, this, u), e;
  },
  b = u.prototype = g.prototype,
  v = ("stack" in d(j)),
  y = ("stack" in new g(1, 2)),
  h = g && m && Object.getOwnPropertyDescriptor(t, j),
  k = !!h && !(h.writable && h.configurable),
  w = v && !k && !y;
r({
  global: !0,
  constructor: !0,
  forced: w
}, {
  DOMException: w ? u : g
});
var x = o(j),
  E = x.prototype;
if (E.constructor !== x) {
  for (var O in f(E, "constructor", s(1, x)), p) if (e(p, O)) {
    var _ = p[O],
      D = _.s;
    e(x, D) || f(x, D, s(6, _.c));
  }
}